import React, { useState } from "react";

function ListItem({ news }) {
  const [localNews] = useState(news);
  
  return (
    <div className="row mb-4 ">
      <div className="col-lg-3 col-md-6 col-sm-12">
        <img src={ localNews.image?.[0]?.signedUrl } className="img-fluid" alt="" />
        
      </div>
      <div className="col-lg-9 col-md-6 col-sm-12 d-flex flex-column justify-content-around">
        <div>
          <h6 className="fw-bold text-decoration-underline mt-3">{ localNews.title }</h6>
          <p className="small">
            { localNews.description }
          </p>
        </div>
        <p className="text-secondary small fst-italic">
          {
            `Le ${new Date(localNews.date).toLocaleDateString('fr-FR')}`
          }
          {
            localNews.location &&
            <><br/>{localNews.location}</>
          }
          {
            localNews.link &&
            <><br/><a href={localNews.link} target="_blank" rel="noopener noreferrer">{localNews.textlink}</a></>
          }
          
        </p>
      </div>
    </div>
  );
}

export default ListItem;